/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandalonePostActionDialog as ResolvedStandalonePostActionDialog } from 'base/components/standalone/PostActionDialog';

export const PostActionDialog: typeof ResolvedStandalonePostActionDialog = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandalonePostActionDialog {...props} />
    );
});

export type PostActionDialogProps = PropsFromComponent<typeof PostActionDialog>;

/** @deprecated Use slot architecture instead */
export const PostActionDialogWith = (extras: DynamicStandaloneExtras): typeof PostActionDialog => {
    return function PostActionDialog(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'PostActionDialog');
        return <ResolvedStandalonePostActionDialog {...mergeProps({ options: { theme } }, props)} />;
    }
}